import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0;

  @media (max-width: 768px) {
    display: grid;
  }

  .signup-content {
    h3 {
      color: #002666;
      font-weight: bold;
      margin-bottom: 16px;
    }

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 20px;
      }

      input {
        border: 2px solid #303030;
        border-radius: 10px;
        width: 100%;
        height: 80px;
        font-size: 24px;
        padding-left: 20px;
        color: black;
      }
      select {
        border: 2px solid #303030;
        border-radius: 10px;
        width: 100%;
        height: 80px;
        font-size: 24px;
        padding-left: 20px;
        color: black;
        -webkit-appearance: none;
        -moz-appearance: none;
        background: 'blue';
      }

      textarea {
        border: 2px solid #303030;
        border-radius: 10px;
        width: 100%;
        height: 200px;
        font-size: 24px;
        padding-left: 20px;
        padding-top: 18px;
        color: black;
      }
    }
  }

  .signup-top-section {
    padding: 60px 0;
    display: flex;
    justify-content: space-between;

    form {
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      @media (max-width: 768px) {
      flex-direction: column;
  }
    }
  }

  .signup-top-section-left {
    width: 35%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    @media (max-width: 768px) {
      width: 100%;
      align-items: center;
  }

    input {
      border: none;
      padding: 10px 40px;
      background: #ce1720;
      color: #fff;
      border-radius: 10px;
      font-size: 24px;
      font-weight: bold;
    }
    .container {
      margin: 0;
      padding: 0;
      width: 350px;
      .row {
        margin: 0;
        display: flex;
        justify-content: space-between;
      }
      i {
        font-size: 20pt;
      }
    }
  }

  .signup-photo-circle {
    border: 3px dashed #303030;
    color: #303030;
    height: 350px;
    width: 350px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    p {
      font-size: 18px;
    }

    i {
      font-size: 50px;
      margin-bottom: 15px;
    }
  }
  .circle {
    border: 3px dashed #303030;
    color: #303030;
    width: 165px;
    height: 165px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  .signup-top-section-right {
    width: 65%;

    @media (max-width: 768px) {
      width: 100%;
      display: flex;
  }
  }

  .signup-form-row {
    display: flex;
    flex-direction: row;

    div {
      width: 50%;
    }
  }

  .signup-mid-section {
    width: 1400px;

    h1 {
      color: #fff;
      font-size: 48px;
      margin-top: 70px;
      margin-bottom: 100px;
      font-weight: bold;
    }
  }

  .signup-plan-card {
    background: #fff;
    width: 30%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    text-align: center;

    h3 {
      border-bottom: 2px solid #e7e6e6;
      font-size: 40px;
      padding-top: 30px;
      padding-bottom: 15px;
    }

    h2 {
      border-bottom: 2px solid #e7e6e6;
      font-size: 60px;
      margin-bottom: 20px;
      padding-bottom: 10px;
      font-weight: bold;
    }

    span {
      font-size: 32px;
      font-weight: normal;
      position: relative;
      top: -20px;
    }

    strong {
      font-size: 32px;
      font-weight: normal;
      font-variant-position: sub;
    }

    p {
      border-bottom: 2px solid #e7e6e6;
      color: #737373;
      font-size: 24px;
      margin: 20px 50px 0px 50px;
    }

    button {
      border: none;
      border-radius: 10px;
      background: #009fea;
      color: #fff;
      font-size: 22px;
      margin-top: 30px;
      margin-bottom: 60px;
      padding: 15px 60px;
    }

    &:hover {
      background: #009fea;
      color: #fff;

      h2,
      h3,
      p {
        border-color: #00b4e9;
        color: #fff;
      }

      button {
        background: #0e0e0e;
      }
    }
  }

  .signup-bot-section {
    padding: 40px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: 1s;

    button {
      border: none;
      border-radius: 10px;
      width: 370px;
      height: 80px;
      background: #ce1720;
      color: #fff;
      font-size: 28px;
      font-weight: bold;
    }

    p {
      color: #fff;
      font-size: 22px;
      height: 80px;
      position: relative;
      margin: 0;
      top: 15px;
      &:last-child {
        position: initial;
        margin: 50px 0;
        height: 0px;
      }
    }
  }
`;
